import React from "react";
import { Message } from "../../../components";
import { COLOR } from "../../../components/theme";

export const AccountFetchError = ({color}) => (
  <Message
    severity="warning-or-significant"
    bg={COLOR.RED_100}
    title="Oops, there was a problem retrieving your account information"
    color={color}
  >
    Please return to cart and select an alternative payment method.
  </Message>
);
